export default "__VITE_ASSET__BzBefR4m__";